import LegalLayout from './LegalLayout';
import { OPERATOR } from './meta';

// Unity WebGL ビューア（リッチ版）の撮影スタジオセットに使っている Sketchfab 配布モデルの
// クレジット表記ページ。CC BY 4.0（Creative Commons Attribution 4.0）は利用にあたって
// 「表示（Attribution）」を義務付けており、改変を加えた場合はその旨の明記も必要
// （creativecommons.org/licenses/by/4.0/ の Adaptations 条項）。
// unity-webgl/Assets/Art/StudioSet/LICENSE.txt にも同内容を記録している。
export default function Credits() {
  return (
    <LegalLayout title="クレジット・使用素材" enacted={OPERATOR.effectiveDate}>
      <p>
        {OPERATOR.serviceName}
        のアニメーション詳細画面から利用できる Unity WebGL ビューア（リッチ版）は、背景の
        撮影スタジオセットとして Sketchfab で配布されている3Dモデルを使用しています。
        ライセンス条項に基づき、以下のとおり出典を表示します。
      </p>

      <h2>撮影スタジオセット（Photo Studio）</h2>
      <dl className="legal__dl">
        <dt>作品名</dt>
        <dd>Photo Studio</dd>
        <dt>作者</dt>
        <dd>
          <a href="https://sketchfab.com/zachey01" target="_blank" rel="noopener noreferrer">
            Zachey
          </a>
        </dd>
        <dt>ライセンス</dt>
        <dd>
          <a href="http://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">
            CC BY 4.0（Creative Commons Attribution 4.0 International）
          </a>
        </dd>
        <dt>出典</dt>
        <dd>
          <a
            href="https://sketchfab.com/3d-models/photo-studio-c63a2e09fb874aac911482289245affd"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sketchfab: Photo Studio
          </a>
        </dd>
      </dl>

      <h2>加えた改変</h2>
      <p>
        CC BY 4.0 は、原作品から改変を加えた場合にその旨を明記することを求めています。
        本サービスでは原作品に対して次の改変を行っています。
      </p>
      <ul>
        <li>
          撮影スタジオの演出に不要なオブジェクト（作業机・周辺機器・隣接する廊下・当たり判定用の
          巨大な非表示ボックス等）を除去しています。
        </li>
        <li>壁・床の配色を、本サービスのビューアの背景トーンに合わせて変更しています。</li>
      </ul>

      <p className="legal__meta">制定日: {OPERATOR.effectiveDate}</p>
    </LegalLayout>
  );
}
